// Helper method for formatting a message
export const createMessage = ({
  body,
  id,
  isUser,
  sideChannels,
  media,
  tags = [],
  title,
  correlationId,
  action_type = "chat",
}) => {
  const message = {
    action: "chat",
    action_type,
    sessionId: isUser ? null : id,
    userId: isUser ? id : null,
    content: {
      body: body.length > 0 ? body : null,
    },
  };

  message.sideChannels = sideChannels;
  message.content.media = media;
  message.tags = tags;

  if (correlationId) {
    message.correlationId = correlationId;
  }

  if (title) {
    message.content.title = title;
  }

  return message;
};

// Helper for creating a note
export const createNote = ({ body, id, media, tags = [] }) => {
  const note = {
    action: "note",
    sessionId: id,
    userId: null,
    content: {
      body: body.length > 0 ? body : null,
    },
  };

  note.content.media = media;
  note.tags = tags;

  return note;
};

// Helper for creating a typing event
export const createTypingEvent = (id, isUser) => {
  const event = {
    action: "typing",
    sessionId: isUser ? null : id,
    userId: isUser ? id : null,
    content: null,
  };

  return event;
};

// Helper for formatting user
export const constructUser = (id, name) => {
  return { id, name };
};
